import { client } from '../client';
import { INotification } from './types/INotification';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const acknowledgeNotificationsByUserId = async (
  user_id: number,
  userRole?: string,
): Promise<INotification[]> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post(`${prefix}/notifications/by-user/${user_id}`);

  return data;
};
